export const SET_FORM_ERROR = "LOGIN.SET_FORM_ERROR";
export function SetLoginFormError(value) {
  return { type: SET_FORM_ERROR, data: value };
}

export const SET_VIEW_FORGOTPASSWORD = "LOGIN.SET_VIEW_FORGOTPASSWORD";
export function SetViewForgotPassword(value) {
  return { type: SET_VIEW_FORGOTPASSWORD, data: value };
}
